











import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import questResult from '@/components/polls/questResult.vue'
import {QuestResult, Anscnt} from '@/types/entity/RawPoll'
import Poll from '@/models/polls/Poll'
export default Vue.extend({
  props: {
    scope: {} as () => {poll: Poll},
    options: {}
  },
  components: {
    infoRowsBlock,
    questResult
  },
  methods: {
    getQuestResult (qid: string): Anscnt[] | undefined {
      let result = this.scope.poll.getQuestResult(qid)
      if (result) {
        return this.scope.poll.getQuestResult(qid)!.anscnt;
      }
    }
  }
})
